module.exports = __webpack_public_path__ + "static/commerce2x-commerce-two-5b901447203afaf6a6e32bc78f77b2e1.jpg";